

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class ProductWarehouseLocation_ManagedObject

class ProductWarehouseLocation_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: value
    set value(value:string) {
        this.setValueForKey(value, 'value');
    }
    get value():string {
        return this.valueForKey('value');
    }
    set valuePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'value');
    }
    get valuePrimitiveValue():string {
        return this.primitiveValueForKey('value');
    }
    // Relationship: product
    set product(value:Product) {
        this.setValueForKey(value, 'product');
    }
    get product():Product {
        return this.valueForKey('product') as Product;
    }
    // Relationship: warehouse
    set warehouse(value:Warehouse) {
        this.setValueForKey(value, 'warehouse');
    }
    get warehouse():Warehouse {
        return this.valueForKey('warehouse') as Warehouse;
    }
    // Relationship: warehouseLocation
    set warehouseLocation(value:WarehouseLocation) {
        this.setValueForKey(value, 'warehouseLocation');
    }
    get warehouseLocation():WarehouseLocation {
        return this.valueForKey('warehouseLocation') as WarehouseLocation;
    }
}
